import { API } from '../../../config'

export const updateJobPreference = (value, successCB, failedCB) => async dispatch => {
  API.POST('/profile/job-preference', value).then((response) => {
    return successCB && successCB(response)
  })
  .catch((err) => {
    return failedCB && failedCB(err.error || err.message)
  })
}